var ProductSetComponent = Vue.component('product-set', {
    extends: ProductComponent,
    components: {
        'product': ProductComponent,
        'product-cart': ProductCartComponent
    },
    created: function() {
        for (var i = 0; i < this.product.products.length; i++) {
            this.$store.commit('addProduct', this.product.products[i]);
        }
    },
    methods: {
        addDiscount: function(price) {
            if (this.product.product_set.discount > 0) {
                price = price - (price * (this.product.product_set.discount / 100));
            }

            if (this.product.product_set.rounding == 'round') {
                price = Math.round(price);
            }

            if (this.product.product_set.rounding == 'ceil') {
                price = Math.ceil(price);
            }

            if (this.product.product_set.rounding == 'floor') {
                price = Math.floor(price);
            }

            return price;
        },
    },
    computed: {
        moduleData: function() {
            var response = {
                'products_set': []
            };

            for (var i = 0; i < this.product.products.length; i++) {
                var p = this.product.products[i];

                response['products_set'].push({
                    'id': p.id,
                    'name': p.name,
                    'model': p.model,
                    'image': this.thumbnail(p.image, 'xs'),
                    'price': p.price,
                    'price_vat': p.price_vat,
                    'product_variation_id': p.product_variation_id
                });
            }

            return response;
        },
        isAvailable: function() {
            for (var i = 0; i < this.product.products.length; i++) {
                if (!this.product.products[i].is_available) {
                    return false;
                }
            }

            return true;
        },
        productModel: function() {
            return _.pluck(this.product.products, 'model').join(' + ');
        },
        productPrice: function() {
            if (!this.product) {
                return 0;
            }

            if (this.product.product_set.type == 'price') {
                return Format.price(this.product.price);
            }

            return Format.price(this.addDiscount(_.pluck(this.product.products, 'price').reduce(function(acc, val) {
                return acc + val;
            })));
        },
        productPriceVat: function () {
            if (!this.product) {
                return 0;
            }

            if (this.product.product_set.type == 'price') {
                return Format.price(this.product.price_vat);
            }

            return Format.price(this.addDiscount(_.pluck(this.product.products, 'price_vat').reduce(function(acc, val) {
                return acc + val;
            })));
        },
        productPriceFinal: function () {
            return Eshop.options.pricesWithVat ? this.productPriceVat : this.productPrice;
        },
        productOldPrice: function () {
            if (!this.product) {
                return 0;
            }

            return Format.price(_.pluck(this.product.products, 'price').reduce(function(acc, val) {
                return acc + val;
            }));
        },
        productOldPriceVat: function () {
            if (!this.product) {
                return 0;
            }

            return Format.price(_.pluck(this.product.products, 'price_vat').reduce(function(acc, val) {
                return acc + val;
            }));
        },
        productOldPriceFinal: function () {
            return Eshop.options.pricesWithVat ? this.productOldPriceVat : this.productOldPrice;
        },
        setStatus: function () {
            var result = '',
                simpleStatusArray = this.product.products.map(({name, status, status_color}) => ({name, status, status_color}));

            simpleStatusArray.forEach(elem => {
                result += elem.name + ': <br><span style="color: ' + elem.status_color + ';">' + elem.status + '</span><br><br>';
            });

            return result;
        }
    }
});
